import { AppPhase } from '../types';

/** Phases that belong to the Grade workspace (flagship productivity flow). */
const GRADE_WORKSPACE_PHASES = new Set<AppPhase>([
  AppPhase.DASHBOARD,
  AppPhase.GRADE_COURSE_PICKER,
  AppPhase.ROSTER_VIEW,
  AppPhase.GRADE_SCAN_SETUP,
  AppPhase.PAPER_ORGANIZE,
  AppPhase.GRADE_BATCH_ROSTER,
  AppPhase.ASSIGNMENT_SELECT,
  AppPhase.ASSIGNMENT_CREATION,
  AppPhase.COURSE_CREATION,
  AppPhase.RUBRIC_SETUP,
  AppPhase.MODE_SELECTION,
  AppPhase.GRADING_LOOP,
  AppPhase.AUDIT,
  AppPhase.GRADE_SYNC_PREFLIGHT,
  AppPhase.SYNCING,
  AppPhase.FINALE,
  AppPhase.PAYWALL,
  AppPhase.SCAN_WORKFLOW,
]);

export function isGradeWorkspacePhase(phase: AppPhase): boolean {
  return GRADE_WORKSPACE_PHASES.has(phase);
}

export function isCommunicatePhase(phase: AppPhase): boolean {
  return phase === AppPhase.RECORDS;
}

export function isTeachPhase(phase: AppPhase): boolean {
  return phase === AppPhase.CLASSROOM;
}

export function isSchedulePhase(phase: AppPhase): boolean {
  return phase === AppPhase.SCHEDULE;
}

export function isPlanPhase(phase: AppPhase): boolean {
  return phase === AppPhase.PLAN;
}

export function isOptionsPhase(phase: AppPhase): boolean {
  return phase === AppPhase.OPTIONS;
}

/** Signed-in hub (AuthView shows SignedInHome). */
export function isHomeHubPhase(phase: AppPhase): boolean {
  return phase === AppPhase.AUTHENTICATION;
}
